import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { DatePicker, FlexColumn } from '~/shared/components';
import { Flex } from '~/shared/components';
import { DateFilterPreset, DateFilterResolutionOption, DatePickerBoxProps } from '../types';
import DateFilterRangeButtons from './DateFilterRangeButtons';
import DateFilterResolutionButtons from './DateFilterResolutionButtons';
import DateFilterModalButton from './DateFilterModalButton';

const DatePickerTitle = styled('div')`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
`;

const DatePickerButtons = styled(Flex)`
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 20px;
  bottom: 8px;
`;

const Wrapper = styled(FlexColumn)<{ hidden: any; $offsetTop: number; $offsetLeft: number }>`
  position: absolute;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  padding: 16px;
  min-width: 435px;
  min-height: 271px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  left: ${({ $offsetLeft }) => `${$offsetLeft}px`};
  top: ${({ $offsetTop }) => `${$offsetTop}px`};
  z-index: 3;
`;

const DatePickerCompWrapper = styled(FlexColumn)`
  margin-top: -15px;
  margin-left: 20px;
`;

const DatePickerCompTitle = styled('div')`
  margin-top: 20px;
  margin-left: 0px;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  color: #667686;
  left: 50%;
`;

const DatePickerEditor = ({
  name,
  value,
  isHidden,
  setIsHidden,
  handleSave,
  dateType,
  options,
  onDateChange,
  isTimeResolution,
  filters,
  dateFilter,
  onCancel,
  rangeValue,
  onRangeChange,
  rangePresets,
  resolutionValue,
  onResolutionChange,
  resolutionOptions,
  positionOverride,
}: DatePickerBoxProps) => {
  const resolvedPresets: DateFilterPreset[] | undefined = rangePresets;
  const resolvedResolutionOptions: DateFilterResolutionOption[] | undefined = resolutionOptions;

  const offsetTop = positionOverride?.top ?? 70;
  const offsetLeft = positionOverride?.left ?? 50;

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    setIsHidden(true);
  };

  return (
    <Wrapper hidden={isHidden ? 1 : 0} $offsetTop={offsetTop} $offsetLeft={offsetLeft}>
      <DatePickerTitle>Select formation and date</DatePickerTitle>
      {isTimeResolution ? (
        <DateFilterResolutionButtons
          filters={filters}
          options={resolvedResolutionOptions || options}
          value={resolutionValue}
          onChange={onResolutionChange}
        />
      ) : (
        <DateFilterRangeButtons presets={resolvedPresets} value={rangeValue} onChange={onRangeChange} />
      )}
      <DatePickerButtons>
        <DateFilterModalButton text="Cancel" onClick={handleCancel} secondary />
        <DateFilterModalButton text="Apply" onClick={handleSave} />
      </DatePickerButtons>
      <DatePickerCompWrapper>
        <DatePickerCompTitle>Date</DatePickerCompTitle>
        {!isHidden && (
          <DatePicker
            {...{
              isInput: true,
              name,
              value: dayjs(value),
              onChange: onDateChange,
              type: dateType,
              label: name,
              options,
              dateFilter,
            }}
          />
        )}
      </DatePickerCompWrapper>
    </Wrapper>
  );
};

export default DatePickerEditor;
